const addScriptTagToBody = (src: string): void => {
  const s = document.createElement("script");
  s.setAttribute("src", src);
  document.body.appendChild(s);
};

export default addScriptTagToBody;
